// 项目经理的静态菜单
export default [{
        "id": "2",
        "data": {
            "menuName": "施工安全考评",
            "menuCode": "",
            "to": "/"
        },
        "children": [{
                "data": {
                    "menuName": "施工项目考评",
                    "menuCode": "cstProject",
                    "to": ""
                },
                "children": [{
                        "data": {
                            "menuName": "项目月考评（登记）",
                            "menuCode": "monthCheckRegist",
                            "to": "/safetyCheck/cstProject/monthCheckRegist",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "项目月考评（查看）",
                            "menuCode": "monthCheckQuery",
                            "to": "/safetyCheck/cstProject/monthCheckQuery",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "项目月考评（签章）-总监/建设负责人",
                            "menuCode": "monthCheckSign",
                            "to": "/safetyCheck/cstProject/monthCheckSign",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "项目竣工考评（填报）",
                            "menuCode": "doneCheckRegist",
                            "to": "/safetyCheck/cstProject/doneCheckRegist",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "竣工考评结果公示书",
                            "menuCode": "doneResultPublicity",
                            "to": "/safetyCheck/cstProject/doneResultPublicity",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "竣工考评结果告知书",
                            "menuCode": "doneResultInform",
                            "to": "/safetyCheck/cstProject/doneResultInform",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "项目考评异议核实（查看）",
                            "menuCode": "objectionCheckQuery",
                            "to": "/safetyCheck/cstProject/objectionCheckQuery",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "项目考评异议复核（查看）",
                            "menuCode": "objectionRecheckQuery",
                            "to": "/safetyCheck/cstProject/objectionRecheckQuery",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "撤销项目考评结果（查看）",
                            "menuCode": "revokeCheckResQuery",
                            "to": "/safetyCheck/cstProject/revokeCheckResQuery",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "撤销项目考评结果公式书",
                            "menuCode": "revokeCheckResPublicity",
                            "to": "/safetyCheck/cstProject/revokeCheckResPublicity",
                            skipCode: ""
                        },
                        "children": []
                    },
                ]
            },
            {
                "data": {
                    "menuName": "省级标准化优良项目考评",
                    "menuCode": "cstGoodPro",
                    "to": ""
                },
                "children": [{
                        "data": {
                            "menuName": "省级优良项目申报(登记)",
                            "menuCode": "GoodDeclare",
                            "to": "/safetyCheck/cstGoodPro/GoodDeclare",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "省级优良项目创建工程汇总表",
                            "menuCode": "GoodSum",
                            "to": "/safetyCheck/cstGoodPro/GoodSum",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "优良项目申报(审批)",
                            "menuCode": "B7",
                            "to": "com.hymake.remaius.safety.goodprj.goodProjectSpMain.flow",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "优良项目申报(查看)",
                            "menuCode": "B5",
                            "to": "com.hymake.remaius.safety.goodprj.goodProjectSearchMain.flow",
                            skipCode: ""
                        },
                        "children": []
                    },

                ]
            },
            {
            	"data": {
                    "menuName": "设区市标准化优良项目考评",
                    "menuCode": "",
                    "to": ""
                },
	                "children": [
	                {
	                	"data": {
		                    "menuName": "设区市优良项目创建工程汇总表",
		                    "menuCode": "districts",
		                    "to": "/community/districts",
		                    skipCode: ""
		                },
		                "children": []
	                },
	                {
	                	"data": {
		                    "menuName": "设区市优良项目创建工程登记",
		                    "menuCode": "registrationMain",
		                    "to": "/community/registration/registrationMain",
		                    skipCode: ""
		                },
		                "children": []
	                },
                ]
            },
        ]
    },
    {
        "id": "2",
        "data": {
            "menuName": "项目管理",
            "menuCode": "2",
            "to": ""
        },
        "children": [{
                "data": {
                    "menuName": "人员请假",
                    "menuCode": "",
                    "to": "",
                    skipCode: ""
                },
                "children": [{
                    "data": {
                        "menuName": "人员请假申请",
                        "menuCode": "personLeaveApply",
                        "to": "/materials/personLeave/personLeaveApply",
                        skipCode: ""
                    },
                    "children": []
                },{
                    "data": {
                        "menuName": "人员请假审批",
                        "menuCode": "personLeaveAudit",
                        "to": "/materials/personLeave/personLeaveAudit",
                        skipCode: ""
                    },
                    "children": []
                },{
                    "data": {
                        "menuName": "历次请假情况查询",
                        "menuCode": "personLeaveQuery",
                        "to": "/materials/personLeave/personLeaveQuery",
                        skipCode: ""
                    },
                    "children": []
                } ]
            }, {
                "data": {
                    "menuName": "建设工程主要材料报审及溯源公示平台",
                    "menuCode": "mainMaterialsSR",
                    "to": "",
                    skipCode: ""
                },
                "children": [{
                        "data": {
                            "menuName": "建设工程主要材料报审",
                            "menuCode": "materialsCheck",
                            "to": "/materials/mainMaterialsSR/materialsCheck",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "主要材料报审记录查看",
                            "menuCode": "materialCheckQuery",
                            "to": "/materials/mainMaterialsSR/materialCheckQuery",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "主要材料溯源公示平台",
                            "menuCode": "materialOriginPublic",
                            "to": "/materials/mainMaterialsSR/materialOriginPublic",
                            skipCode: ""
                        },
                        "children": []
                    },
                ]
            },
            {
                "data": {
                    "menuName": "项目查看",
                    "menuCode": "proMain",
                    "to": "/materials/project",
                    skipCode: ""


                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目报建及日常管理过程查询",
                    "menuCode": "dailyMain",
                    "to": "/materials/administration/dailyMain",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "幕墙登记",
                    "menuCode": "curtainWall",
                    "to": "/materials/curtainWall",
                    skipCode: ""


                },
                "children": []
            },
            {
                "data": {
                    "menuName": "黑名单人员考勤申报",
                    "menuCode": "blacklist",
                    "to": "/materials/blacklist",
                    skipCode: ""


                },
                "children": []
            },
            {
                "data": {
                    "menuName": "危险源管理",
                    "menuCode": "dangerSource",
                    "to": "dangerSource"
                },
                "children": [{
                    "data": {
                        "menuName": "危险源计划查看",
                        "menuCode": "dangerPlan",
                        "to": "/materials/dangerPlan",
                        skipCode: ""


                    },
                    "children": []
                }, {
                    "data": {
                        "menuName": "危险源登记",
                        "menuCode": "dangerRegist",
                        "to": "/materials/dangerRegist",
                        skipCode: ""


                    },
                    "children": []
                }, {
                    "data": {
                        "menuName": "危险源查看与解除",
                        "menuCode": "dangerQR",
                        "to": "/materials/dangerQR",
                        skipCode: ""


                    },
                    "children": []
                }, {
                    "data": {
                        "menuName": "危险源查看",
                        "menuCode": "dangerQury",
                        "to": "/materials/dangerQury",
                        skipCode: ""


                    },
                    "children": []
                }, ]
            },
            {
                "data": {
                    "menuName": "建筑起重机械管理",
                    "menuCode": "",
                    "to": "",
                    skipCode: ""
                },
                "children": [{
                    "data": {
                      "menuName": "建筑起重机械管理",
                      "menuCode": "liftingManage",
                      "to": "/materials/liftingManage",
                      skipCode: ""
                    },
                    "children": []
                },{
                    "data": {
                        "menuName": "起重机械查询",
                        "menuCode": "liftingQuery",
                        "to": "/materials/liftingQuery",
                        skipCode: ""
                    },
                    "children": []
                }]
            },
        ]
    },
    {
        "id": "3",
        "data": {
            "menuName": "远程视频管控",
            "menuCode": "",
            "to": ""
        },
        "children": [{
            "data": {
                "menuName": "远程视频日常管理",
                "menuCode": "",
                "to": ""
            },
            "children": [{
                "data": {
                    "menuName": "远程监控设备安装申请",
                    "menuCode": "installApply",
                    "to": "/video/installApply",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "远程监控设备维护申请",
                    "menuCode": "maintainApply",
                    "to": "/video/maintainApply",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "远程监控设备暂停申请",
                    "menuCode": "pauseApply",
                    "to": "/video/pauseApply",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "远程监控设备恢复申请",
                    "menuCode": "recoveryApply",
                    "to": "/video/recoveryApply",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "远程监控设备拆除申请",
                    "menuCode": "dismantleApply",
                    "to": "/video/dismantleApply",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "远程监控设备安装查询",
                    "menuCode": "installQuery",
                    "to": "/video/installQuery",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "远程监控设备维护查询",
                    "menuCode": "maintainQuery",
                    "to": "/video/maintainQuery",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "远程监控设备暂停查询",
                    "menuCode": "pauseQuery",
                    "to": "/video/pauseQuery",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "远程监控设备恢复查询",
                    "menuCode": "recoveryQuery",
                    "to": "/video/recoveryQuery",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "远程监控设备拆除查询",
                    "menuCode": "dismantleQuery",
                    "to": "/video/dismantleQuery",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "远程监控设备查询",
                    "menuCode": "devQuery",
                    "to": "/video/devQuery",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "远程监控设备与单位工程查询",
                    "menuCode": "devItemQuery",
                    "to": "/video/devItemQuery",
                    skipCode: ""
                },
                "children": []
            },]
        },{
            "data": {
                "menuName": "远程视频查看",
                "menuCode": "",
                "to": ""
            },
            "children": [{
                "data": {
                    "menuName": "视频查看（2017年4月1日之前）",
                    "menuCode": "videoQueryOld",
                    "to": "/video/videoQueryOld",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "视频查看（2017年4月1日之后）",
                    "menuCode": "videoQueryNew",
                    "to": "/video/videoQueryNew",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "黑名单视频查看（2017年4月1日之前）",
                    "menuCode": "videoBlackQueryOld",
                    "to": "/video/videoBlackQueryOld",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "黑名单视频查看（2017年4月1日之后）",
                    "menuCode": "videoBlackQueryNew",
                    "to": "/video/videoBlackQueryNew",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "黑名单项目部人员考勤查看",
                    "menuCode": "peopleBlackQuery",
                    "to": "/video/peopleBlackQuery",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "环境侦测查看",
                    "menuCode": "environmentQuery",
                    "to": "/video/environmentQuery",
                    skipCode: ""
                },
                "children": []
            },]
        },{
            "data": {
                "menuName": "企业远程视频管控应用",
                "menuCode": "",
                "to": "",
            },
            "children": [{
                "data": {
                    "menuName": "检查记录登记及查看",
                    "menuCode": "recordRegister",
                    "to": "/video/videoControl/recordRegister",
                    skipCode: ""
                },
                "children": []
            },{
                "data": {
                    "menuName": "责改单发出及反馈查看",
                    "menuCode": "amendmentSent",
                    "to": "/video/videoControl/amendmentSent",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "检查记录查看",
                    "menuCode": "recordView",
                    "to": "/video/videoControl/recordView",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "责改单查看",
                    "menuCode": "amendmentView",
                    "to": "/video/videoControl/amendmentView",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "责改单反馈",
                    "menuCode": "bussBack",
                    "to": "/video/videoControl/bussBack",
                    skipCode: ""
                },
                "children": []
            },
            ]
        }]
    },
    {
    	"id": "4",
        "data": {
            "menuName": "双随机管理",
            "menuCode": "",
            "to": ""
        },
        "children": [
	        {
	        	"data": {
	                "menuName": "监督检查两个工作事项清单定制",
	                "menuCode": "",
	                "to": "",
	                skipCode: ""
	            },
	            "children": [{
	            	"data": {
                        "menuName": "监管部门两个工作事项清单查询",
                        "menuCode": "inventory",
                        "to": "/management/supervision/inventory",
                        skipCode: ""
                    },
                    	"children": []
	            	}
	            ]
	        },
        ],
    },
    {
    	"id": "5",
        "data": {
            "menuName": "建设单位对监理评价",
            "menuCode": "",
            "to": ""
        },
        "children": [
	        {
	        	"data": {
	                "menuName": "建设单位对监理评价",
	                "menuCode": "evaluate",
	                "to": "/development/evaluate",
	                skipCode: ""
	           },
	           "children": []
	        },
	        {
	        	"data": {
	                "menuName": "评价结果电子签章",
	                "menuCode": "consequence",
	                "to": "/development/consequence",
	                skipCode: ""
	           },
	           "children": []
	        },
        ],
    },
	{
        "id": "6",
        "data": {
            "menuName": "施工合同备案",
            "menuCode": "",
            "to": ""
        },
        "children": [
            {
                "data": {
                    "menuName": "合同备案",
                    "menuCode": "contractRecord",
                    "to": "/contractRecord/contractRecord",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "补充合同（协议）备案管理",
                    "menuCode": "replenishContract",
                    "to": "/contractRecord/replenishContract",
                    skipCode: ""
                },
                "children": []
            },
        ]
    },
    {
        "id": "7",
        "data": {
            "menuName": "施工合同管理",
            "menuCode": "",
            "to": ""
        },
        "children": [
	        {
	            "data": {
	                "menuName": "人员实名制管理",
	                "menuCode": "realNameSystem",
	                "to": "/contractRecord/realNameSystem",
	                skipCode: ""
	            },
	            "children": []
	        },
	        {
	            "data": {
	                "menuName": "合同履约情况备案",
	                "menuCode": "perForMance",
	                "to": "/contractRecord/perForMance",
	                skipCode: ""
	            },
	            "children": []
	        },
	        {
	            "data": {
	                "menuName": "施工产值查询",
	                "menuCode": "rendImiento",
	                "to": "/contractRecord/rendImiento",
	                skipCode: ""
	            },
	            "children": []
	        },
	        {
	            "data": {
	                "menuName": "项目季度产值填报",
	                "menuCode": "quarTerly",
	                "to": "/contractRecord/quarTerly/quarTerly",
	                skipCode: ""
	            },
	            "children": []
	        },
	        {
	            "data": {
	                "menuName": "施工合同竣工结算送审信息填报",
	                "menuCode": "finalInspection",
	                "to": "/contractRecord/quarTerly/finalInspection",
	                skipCode: ""
	            },
	            "children": []
	        },
	        {
	            "data": {
	                "menuName": "工程款支付情况填报",
	                "menuCode": "projectFunds",
	                "to": "/contractRecord/quarTerly/projectFunds",
	                skipCode: ""
	            },
	            "children": []
	        },
            {
                "data": {
                    "menuName": "工程项目合同履约暂不评价申请",
                    "menuCode": "projectNoEvluation",
                    "to": "/contractRecord/projectNoEvluation",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "恢复工程项目合同履约暂不评价申请",
                    "menuCode": "projectNoEvluationRemove",
                    "to": "/contractRecord/projectNoEvluationRemove",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "劳务管理免评项目申请",
                    "menuCode": "projectFreeEval",
                    "to": "/contractRecord/projectFreeEval",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "加分项目申请",
                    "menuCode": "projectApply",
                    "to": "/contractRecord/projectApply",
                    skipCode: ""
                },
                "children": []
            },
        ]
    },
    {
        "id": "8",
        "data": {
            "menuName": "施工合同信息查询",
            "menuCode": "",
            "to": ""
        },
        "children": [
            {
                "data": {
                    "menuName": "企业合同备案信息查询",
                    "menuCode": "contractQuery",
                    "to": "/contractRecord/contractQuery",
                    skipCode: ""
                },
                "children": []
            },
        ]
    },
    {
        "id": "9",
        "data": {
            "menuName": "项目督（巡）查",
            "menuCode": "",
            "to": ""
        },
        "children": [
            {
                "data": {
                    "menuName": "已发布文件查看",
                    "menuCode": "perSonne",
                    "to": "/management/personne/perSonne",
                    skipCode: ""
                },
                "children": []
            },
        ]
    },
    {
        "id": "10",
        "data": {
            "menuName": "责任主体监管信息查询平台 ",
            "menuCode": "",
            "to": ""
        },
        "children": [
            {
                "data": {
                    "menuName": "责令改正通知书",
                    "menuCode": "correctNotice",
                    "to": "/dailySupervision/correctNotice",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "记分告知单",
                    "menuCode": "",
                    "to": "",
                    skipCode: ""
                },
                "children": [
                    {
                        "data": {
                            "menuName": "公示期的记分告知单",
                            "menuCode": "scoreNotice2",
                            "to": "/dailySupervision/scoreNotice2",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "已生效的记分告知单",
                            "menuCode": "scoreNotice1",
                            "to": "/dailySupervision/scoreNotice1",
                            skipCode: ""
                        },
                        "children": []
                    },
                ]
            },
            {
                "data": {
                    "menuName": "合同履约评价单",
                    "menuCode": "",
                    "to": "",
                    skipCode: ""
                },
                "children": [
                    {
                        "data": {
                            "menuName": "公示期的合同履约评价单",
                            "menuCode": "publicityPeriod",
                            "to": "/dailySupervision/contractCompliance/publicityPeriod",
                            skipCode: ""
                        },
                        "children": []
                    },
                    {
                        "data": {
                            "menuName": "已生效的合同履约评价单",
                            "menuCode": "tookEffect",
                            "to": "/dailySupervision/contractCompliance/tookEffect",
                            skipCode: ""
                        },
                        "children": []
                    },
                ]
            },
        ]
    },
    {
        "id": "11",
        "data": {
            "menuName": "项目工程经理变更管理 ",
            "menuCode": "",
            "to": ""
        },
        "children": [
            {
                "data": {
                    "menuName": "项目工程经理变更申请",
                    "menuCode": "modifyIndex",
                    "to": "/managerModify/modifyIndex",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程经理变更审核",
                    "menuCode": "modifyCheck",
                    "to": "/managerModify/modifyCheck",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程经理变更历史记录查看",
                    "menuCode": "modifyRecord",
                    "to": "/managerModify/modifyRecord",
                    skipCode: ""
                },
                "children": []
            }
        ]
    },
    {
        "id": "12",
        "data": {
            "menuName": "项目工程总监变更管理 ",
            "menuCode": "",
            "to": ""
        },
        "children": [
            {
                "data": {
                    "menuName": "项目工程总监变更申请",
                    "menuCode": "directorIndex",
                    "to": "/managerModify/director/directorIndex",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程总监变更审核",
                    "menuCode": "directorCheck",
                    "to": "/managerModify/director/directorCheck",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程总监变更历史记录查看",
                    "menuCode": "directorRecord",
                    "to": "/managerModify/director/directorRecord",
                    skipCode: ""
                },
                "children": []
            }
        ]
    },
    {
        "id": "13",
        "data": {
            "menuName": "项目工程施工单位变更管理 ",
            "menuCode": "",
            "to": ""
        },
        "children": [
            {
                "data": {
                    "menuName": "项目工程施工单位变更申请",
                    "menuCode": "constructionIndex",
                    "to": "/managerModify/construction/constructionIndex",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程施工单位变更审核",
                    "menuCode": "constructionCheck",
                    "to": "/managerModify/construction/constructionCheck",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程施工单位变更历史记录查看",
                    "menuCode": "constructionRecord",
                    "to": "/managerModify/construction/constructionRecord",
                    skipCode: ""
                },
                "children": []
            }
        ]
    },
    {
        "id": "14",
        "data": {
            "menuName": "项目工程监理单位变更管理 ",
            "menuCode": "",
            "to": ""
        },
        "children": [
            {
                "data": {
                    "menuName": "项目工程监理单位变更申请",
                    "menuCode": "supervisorIndex",
                    "to": "/managerModify/supervision/supervisorIndex",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程监理单位变更审核",
                    "menuCode": "supervisorCheck",
                    "to": "/managerModify/supervision/supervisorCheck",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程监理单位变更历史记录查看",
                    "menuCode": "supervisorRecord",
                    "to": "/managerModify/supervision/supervisorRecord",
                    skipCode: ""
                },
                "children": []
            }
        ]
    },
    {
        "id": "15",
        "data": {
            "menuName": "项目工程完工管理 ",
            "menuCode": "",
            "to": ""
        },
        "children": [
            {
                "data": {
                    "menuName": "项目工程完工申请",
                    "menuCode": "completionIndex",
                    "to": "/managerModify/completion/completionIndex",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程完工登记审核",
                    "menuCode": "completionCheck",
                    "to": "/managerModify/completion/completionCheck",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程完工登记查询",
                    "menuCode": "completionRecord",
                    "to": "/managerModify/completion/completionRecord",
                    skipCode: ""
                },
                "children": []
            }
        ]
    },
    {
        "id": "16",
        "data": {
            "menuName": "项目工程竣工管理 ",
            "menuCode": "",
            "to": ""
        },
        "children": [
            {
                "data": {
                    "menuName": "项目工程竣工申请",
                    "menuCode": "closeoutIndex",
                    "to": "/managerModify/closeout/closeoutIndex",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程竣工登记审核",
                    "menuCode": "closeoutCheck",
                    "to": "/managerModify/closeout/closeoutCheck",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程竣工登记查询",
                    "menuCode": "closeoutRecord",
                    "to": "/managerModify/closeout/closeoutRecord",
                    skipCode: ""
                },
                "children": []
            }
        ]
    },
    {
        "id": "17",
        "data": {
            "menuName": "项目工程竣工验收备案 ",
            "menuCode": "",
            "to": ""
        },
        "children": [
            {
                "data": {
                    "menuName": "项目工程竣工验收备案发起",
                    "menuCode": "approvalIndex",
                    "to": "/managerModify/approval/approvalIndex",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程竣工验收备案审核",
                    "menuCode": "approvalCheck",
                    "to": "/managerModify/approval/approvalCheck",
                    skipCode: ""
                },
                "children": []
            },
            {
                "data": {
                    "menuName": "项目工程竣工验收备案查询",
                    "menuCode": "approvalRecord",
                    "to": "/managerModify/approval/approvalRecord",
                    skipCode: ""
                },
                "children": []
            }
        ]
    },
    {
        "id": "19",
        "data": {
            "menuName": "统计查询 ",
            "menuCode": "queryCount",
            "to": "/managerModify/queryCount"
        },
        "children": []
    },
]



// WEBPACK FOOTER //
// ./src/static/js/menu_man.js